import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";

class DeleteAccount extends Component {
  constructor() {
    super();

    this.deleteAccount = this.deleteAccount.bind(this);
  }

  deleteAccount() {
    this
      .props
      .userSettingsActions
      .deleteAccount()
      .then(() => {
        this.props.history.push({ pathname: "/" });
      });
  }

  render() {
    return (
      <div className={styles.grayOverlay}>
        <div className={styles.deleteAccountBox}>
          <h2>Are you sure you want to delete your account?</h2>

          <div className={styles.grayText}>
            This action is permanent and cannot be reversed.
          </div>

          <div>
            <button onClick={this.deleteAccount} className={classNames(styles.deleteConfirmButton, styles.blueButton1)}>
              Yes, delete
            </button>
          </div>

          <div>
            <button onClick={this.props.toggleDeleteAccount} className={classNames(styles.cancelDeleteButton, styles.grayButton1)}>
              No, cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteAccount));



// WEBPACK FOOTER //
// ./src/users/components/UserSettings/DeleteAccount.js